import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Firsttable from "../report/component/Firsttable";
import DashboardCharts from "./component/DashboardCharts";
import DataComp from "./component/DataComp";
import { Box, styled } from "@mui/system";
import {
  useCreateReportMutation,
  useFetchManagerByUserQuery,
  useGeneratePresignedUrlMutation,
  useSendEmailMutation,
} from "../../services/reportService";
import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Alert, Button, IconButton, Snackbar, TextField } from "@mui/material";
import { useAddCommentsMutation } from "../../services/user-reportService";
import styles from "./ViewPage.module.css";
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { useFetchCoreActivityQuery } from "../../services/roleReviewService";
// import Header from "../profile/component/Header";
import logos from "../../assets/images/rolereview_logo.png"
import DownloadIcon from '@mui/icons-material/Download';
// import { useReactToPrint } from "react-to-print";
import WorkData from "./component/WorkData";
import ReportFooter from "../../components/Common/ReportFooter";
import ReportHeader from "../../components/Common/ReportHeader";
import { useFetchCurrentUserQuery } from "../../services/profileService";

const ViewPage = () => {
  // const reportRef = useRef();
  const { users } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isJwtUser = location.state?.isJwtUser || false;
  const userIdFromJwt = location.state?.userId;
  const employeeId = isJwtUser ? userIdFromJwt : users?.user_id;
  const role = isJwtUser ? "employee" : users?.role;
  // const [downloadUrl, setDownloadUrl] = useState(null); 
  const [commentText, setCommentText] = useState("");
  const [progress, setProgress] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);
  const [reportVersionId, setReportVersionId] = useState(null);
  // const [reportSaved, setReportSaved] = useState(false);
  const [createReport] = useCreateReportMutation();
  const [addComment] = useAddCommentsMutation();
  const [generatePresignedUrl] = useGeneratePresignedUrlMutation();
  const [sendEmail] = useSendEmailMutation();
  // const { data: coreActivityData } = useFetchCoreActivityQuery(employeeId);
  const { data: managerData } = useFetchManagerByUserQuery(employeeId);
  const { data: userData } = useFetchCurrentUserQuery(employeeId);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');
  

  const managerId = managerData?.data?.manager_id;
  console.log(managerData)
  const TitleWrap = styled('h3')({
    // You can define your styled components here or import them
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '10px',
  });
  
  const CustomBtnSave = styled(Button)({
    // And styled components or regular CSS
    backgroundColor: '#4CAF50',
    color: 'white',
    '&:hover': {
        backgroundColor: '#388E3C',
    },
  });
  useEffect(() => {
    let intervalId; // Store interval ID for cleanup

    const generatePdfOnLoad = async () => {
        setToastMessage('Generating report. Please wait a while...');
        setToastSeverity('info');
        setToastOpen(true);
        setProgress(0); // Start from 0%

        try {
            setIsGenerating(true);

            // Start progress update interval
            intervalId = setInterval(() => {
                setProgress((prev) => (prev < 90 ? prev + 10 : prev)); // Prevent it from reaching 100 before API finishes
            }, 500);

            const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = 210;
      const pageHeight = 297;
      const margin = 10; // margin between header and content
      const bottomMargin = 10; // extra margin before footer
  
      // Capture header
      const headerElement = document.getElementById("pdfHeader");
      headerElement.classList.add(styles.forceHF);
      const roleReviewTitle = document.getElementById("RolerevirTitle");
      const roleReviewContent = document.getElementById("RolerevirContent");
     
    // Increase font size
    const originalTitleFontSize = roleReviewTitle.style.fontSize;
    const originalContentFontSize = roleReviewContent.style.fontSize;
        roleReviewTitle.style.fontSize = "55px"; // Adjust as needed
        roleReviewContent.style.fontSize = "35px";
      const headerCanvas = await html2canvas(headerElement, {
        scale: 2,
        useCORS: true,
      });
      const headerImgData = headerCanvas.toDataURL("image/jpeg",0.6);
      const headerImgHeight = (headerCanvas.height * pageWidth) / headerCanvas.width;
      roleReviewTitle.style.fontSize = originalTitleFontSize;
    roleReviewContent.style.fontSize = originalContentFontSize;
      // Capture footer (hide unwanted elements first)
      const footerElement = document.getElementById("pdfFooter");
      footerElement.classList.add(styles.forceHF);
      const footerTitle = document.getElementById("FooterTitle");
      
     
    // Increase font size
    const originalfooterTitleSize = footerTitle.style.fontSize;
    footerTitle.style.marginBottom = "55px";
    footerTitle.style.fontSize = "46px";
      footerElement.querySelectorAll("a").forEach((a) => (a.style.display = "none"));
      footerElement.querySelectorAll("#forMoreInfo, #contactOrVisit").forEach(
        (span) => (span.style.display = "none")
      );
      const footerCanvas = await html2canvas(footerElement, {
        scale: 2,
        useCORS: true,
      });
      const footerImgData = footerCanvas.toDataURL("image/jpeg",0.6);
      const footerImgHeight = (footerCanvas.height * pageWidth) / footerCanvas.width;
      footerTitle.style.marginBottom = "";
      footerTitle.style.fontSize = originalfooterTitleSize;
      // Restore the footer elements
      footerElement.querySelectorAll("a").forEach((a) => (a.style.display = ""));
      footerElement.querySelectorAll("#forMoreInfo, #contactOrVisit").forEach(
        (span) => (span.style.display = "")
      );
  
      // Function to capture content and add it with automatic pagination
      const captureAndAddToPDF = async (elementId) => {
        // Always add header and footer (footer remains as is)
        const addHeaderAndFooter = () => {
          pdf.addImage(headerImgData, "jpeg", 0, 0, pageWidth, headerImgHeight);
          const logoWidth = 22; // in mm
          const logoHeight = 22; // adjust based on aspect ratio
          pdf.addImage(logos, "PNG", 5, 5, logoWidth, logoHeight);
          pdf.addImage(footerImgData, "jpeg", 0, pageHeight - footerImgHeight, pageWidth, footerImgHeight);
          pdf.setTextColor(255, 255, 255);
          pdf.setFontSize(13);
          const yText = pageHeight - 6;
          pdf.text("For more information, contact", 13, yText);
          pdf.textWithLink("info@activatehcg.com", 75, yText, {
            url: "mailto:info@activatehcg.com",
          });
          pdf.text("or visit our website", 122, yText);
          pdf.textWithLink("ActivateHCG.com", 162, yText, {  
            url: "https://www.activatehcg.com",
          });
        };
  
        // Capture the content element
        const element = document.getElementById(elementId);
        element.classList.add(styles.desktop);
        if (window.innerWidth < 768) {
          element.style.width = "1170px";
          element.classList.add(styles.forceDesktop);
        }
        const contentCanvas = await html2canvas(element, {
          width: 1170, // fixed width for capture
          height: element.offsetHeight,
          scale: 2,
          useCORS: true,
        });
        // const contentImgData = contentCanvas.toDataURL("image/jpeg",0.6);
        // Calculate the rendered height in the PDF (in mm)
        // const contentImgHeight = (contentCanvas.height * pageWidth) / contentCanvas.width;
  
        // Calculate available vertical space for content on each page.
        // We subtract the header height, footer height, top margin and the extra bottom margin.
        const availableHeight = pageHeight - headerImgHeight - footerImgHeight - margin - bottomMargin;
  
        // Create a temporary canvas to hold a slice of the content
        const canvasSlice = document.createElement("canvas");
        canvasSlice.width = contentCanvas.width;
        // The height (in pixels) corresponding to our availableHeight in mm:
        const pixelRatio = contentCanvas.width / pageWidth;
        const sliceHeightPx = availableHeight * pixelRatio;
  
        let yPositionPx = 0; // starting pixel position in contentCanvas
        let pageCount = 0;
  
        while (yPositionPx < contentCanvas.height) {
          // Set the slice height to the remaining height if less than a full slice
          const currentSliceHeight = Math.min(sliceHeightPx, contentCanvas.height - yPositionPx);
          canvasSlice.height = currentSliceHeight;
  
          const ctx = canvasSlice.getContext("2d");
          // Clear previous content
          ctx.clearRect(0, 0, canvasSlice.width, canvasSlice.height);
          // Draw the slice from the original canvas
          ctx.drawImage(
            contentCanvas,
            0,
            yPositionPx,
            contentCanvas.width,
            currentSliceHeight,
            0,
            0,
            canvasSlice.width,
            currentSliceHeight
          );
  
          // Convert this slice to an image
          const sliceData = canvasSlice.toDataURL("image/jpeg");
          // Calculate the slice's height in the PDF
          const slicePdfHeight = (currentSliceHeight * pageWidth) / contentCanvas.width;
  
          // If it's the first page, add header at the top; for additional pages, add a new page and header
          if (pageCount === 0) {
            addHeaderAndFooter();
            // Add the first slice below the header, starting at headerImgHeight + margin
            pdf.addImage(sliceData, "jpeg", 0, headerImgHeight + margin, pageWidth, slicePdfHeight);
          } else {
            pdf.addPage();
            addHeaderAndFooter();
            pdf.addImage(sliceData, "jpeg", 0, headerImgHeight + margin, pageWidth, slicePdfHeight);
          }
  
          yPositionPx += currentSliceHeight;
          pageCount++;
        }
      };
  
      // Capture and add two pages (or more if needed)
      await captureAndAddToPDF("firstPage");
      pdf.addPage();
      await captureAndAddToPDF("secondPage");
  
      // --------------------------
      // Save the PDF
      // --------------------------
    //   const fileName = `report_${employeeId}.pdf`;
        const today = new Date();
        const formattedDate = `${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}-${today.getFullYear()}`;

        // Format the filename
        const employeeName = userData?.data?.name.replace(/\s+/g, "_"); // Replace spaces with underscores
        const fileName = `RoleReview–${employeeName}-${formattedDate}.pdf`;


            const pdfBlob = pdf.output('blob');
            
            URL.createObjectURL(pdfBlob);
            // setDownloadUrl(pdfUrl);

            // Upload PDF to server
            const presignedUrlResponse = await generatePresignedUrl({
                file_name: fileName,
                file_type: 'application/pdf',
            });

            const presignedUrl = presignedUrlResponse?.data?.data?.presigned_url;
            if (presignedUrl) {
              await axios.put(presignedUrl, pdfBlob, {
                headers: {
                  "x-ms-blob-type": "BlockBlob", // Important for Azure Blob
                  "Content-Type": "application/pdf",
                },
              
              });
            }
           

            const formData = new FormData();
            formData.append('user_id', employeeId);
            formData.append('manager_id', managerId);
            formData.append('file', fileName);
            formData.append('role', role);

            const { data } = await createReport(formData);

            if (
                data?.data?.detail ===
                'You can only have up to 4 versions of a report.To create additional versions,please contact the admin for assistance.'
            ) {
                setToastMessage(data.data.detail);
                setToastSeverity('warning');
                setToastOpen(true);
                // navigate('/landing-page');
                if(isJwtUser){
                  setToastMessage(data?.data?.detail);
                  setToastSeverity('success');
                  setToastOpen(true);
                  
                            
                  }else{
                    setToastMessage(data?.data?.detail);
                    setToastSeverity('success');
                    setTimeout(() => {
                      navigate("/landing-page");
                  }, 5000);
                            
                  }
            } else {
                setReportVersionId(data.data.current_version_id);
                setToastMessage('PDF generated successfully.');
                setToastSeverity('success');
                setToastOpen(true);
                
                // Increase progress to 100% only when everything is done
                

                // Send email notification after report generation
                const emailRequest = {
                    recipient_id: employeeId,  
                    recipient_type: 'user',
                    subject: 'Completed Role Review – Your Role Review Report is attached',
                    body: `
                    Please find the attached Role Review Report, powered by Activate Human Capital Group. This activity was completed for one of the following purposes: 
                        -New Role Design/Development
                        -Onboarding
                        -Performance Management
                        -Succession Planning/Retirement
                        -Delegate & Elevate 
                    Next Step: Review this document with your manager to ensure agreement about Core Focus Areas, Priorities, and Activities. The Role Review process was designed to improve clarity of expectations, communications, and the path to career success. Thank you for making this investment of approximately 25 minutes – a little clarity can go a LONG way when it comes to career satisfaction and employee engagement. 
                    For additional support or information, please contact info@activatehcg.com 
                    `,
                    sent_at: new Date().toISOString(),
                };
                setProgress(100);
                await sendEmail(emailRequest);
                
            }
        } catch (error) {
            console.error('Error generating PDF:', error);
            setToastMessage('An error occurred while generating the report. Please try again later.');
            setToastSeverity('error');
            setToastOpen(true);
        } finally {
            setIsGenerating(false);
            clearInterval(intervalId); 
            setProgress(100);// Stop progress updates
            setTimeout(() => setProgress(0), 2000); // Reset progress after completion
        }
    };

    const timeout = setTimeout(() => {
        generatePdfOnLoad();
    }, 1000);

    return () => {
        clearTimeout(timeout);
        clearInterval(intervalId); // Ensure cleanup
    };
}, [employeeId, managerId, role, createReport, generatePresignedUrl, navigate, sendEmail, userData?.data?.name, isJwtUser]);


const handleDownload = async () => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = 210;
      const pageHeight = 297;
      const margin = 10; // margin between header and content
      const bottomMargin = 10; // extra margin before footer
  
      // Capture header
      const headerElement = document.getElementById("pdfHeader");
      headerElement.classList.add(styles.forceHF);
      const roleReviewTitle = document.getElementById("RolerevirTitle");
      const roleReviewContent = document.getElementById("RolerevirContent");
     
    // Increase font size
    const originalTitleFontSize = roleReviewTitle.style.fontSize;
    const originalContentFontSize = roleReviewContent.style.fontSize;
        roleReviewTitle.style.fontSize = "55px"; // Adjust as needed
        roleReviewContent.style.fontSize = "35px";
      const headerCanvas = await html2canvas(headerElement, {
        scale: 2,
        useCORS: true,
      });
      const headerImgData = headerCanvas.toDataURL("image/jpeg",0.6);
      const headerImgHeight = (headerCanvas.height * pageWidth) / headerCanvas.width;
      roleReviewTitle.style.fontSize = originalTitleFontSize;
    roleReviewContent.style.fontSize = originalContentFontSize;
      // Capture footer (hide unwanted elements first)
      const footerElement = document.getElementById("pdfFooter");
      footerElement.classList.add(styles.forceHF);
      const footerTitle = document.getElementById("FooterTitle");
      
     
    // Increase font size
    const originalfooterTitleSize = footerTitle.style.fontSize;
    footerTitle.style.marginBottom = "55px";
    footerTitle.style.fontSize = "46px";
      footerElement.querySelectorAll("a").forEach((a) => (a.style.display = "none"));
      footerElement.querySelectorAll("#forMoreInfo, #contactOrVisit").forEach(
        (span) => (span.style.display = "none")
      );
      const footerCanvas = await html2canvas(footerElement, {
        scale: 2,
        useCORS: true,
      });
      const footerImgData = footerCanvas.toDataURL("image/jpeg",0.6);
      const footerImgHeight = (footerCanvas.height * pageWidth) / footerCanvas.width;
      footerTitle.style.marginBottom = "";
      footerTitle.style.fontSize = originalfooterTitleSize;
      // Restore the footer elements
      footerElement.querySelectorAll("a").forEach((a) => (a.style.display = ""));
      footerElement.querySelectorAll("#forMoreInfo, #contactOrVisit").forEach(
        (span) => (span.style.display = "")
      );
  
      // Function to capture content and add it with automatic pagination
      const captureAndAddToPDF = async (elementId) => {
        // Always add header and footer (footer remains as is)
        const addHeaderAndFooter = () => {
          pdf.addImage(headerImgData, "jpeg", 0, 0, pageWidth, headerImgHeight);
          const logoWidth = 22; // in mm
          const logoHeight = 22; // adjust based on aspect ratio
          pdf.addImage(logos, "PNG", 5, 5, logoWidth, logoHeight);
          pdf.addImage(footerImgData, "jpeg", 0, pageHeight - footerImgHeight, pageWidth, footerImgHeight);
          pdf.setTextColor(255, 255, 255);
          pdf.setFontSize(13);
          const yText = pageHeight - 6;
          pdf.text("For more information, contact", 13, yText);
          pdf.textWithLink("info@activatehcg.com", 75, yText, {
            url: "mailto:info@activatehcg.com",
          });
          pdf.text("or visit our website", 122, yText);
          pdf.textWithLink("ActivateHCG.com", 162, yText, {  
            url: "https://www.activatehcg.com",
          });
        };
  
        // Capture the content element
        const element = document.getElementById(elementId);
        element.classList.add(styles.desktop);
        if (window.innerWidth < 768) {
          element.style.width = "1170px";
          element.classList.add(styles.forceDesktop);
        }
        const contentCanvas = await html2canvas(element, {
          width: 1170, // fixed width for capture
          height: element.offsetHeight,
          scale: 2,
          useCORS: true,
        });
        // const contentImgData = contentCanvas.toDataURL("image/jpeg",0.6);
        // Calculate the rendered height in the PDF (in mm)
        // const contentImgHeight = (contentCanvas.height * pageWidth) / contentCanvas.width;
  
        // Calculate available vertical space for content on each page.
        // We subtract the header height, footer height, top margin and the extra bottom margin.
        const availableHeight = pageHeight - headerImgHeight - footerImgHeight - margin - bottomMargin;
  
        // Create a temporary canvas to hold a slice of the content
        const canvasSlice = document.createElement("canvas");
        canvasSlice.width = contentCanvas.width;
        // The height (in pixels) corresponding to our availableHeight in mm:
        const pixelRatio = contentCanvas.width / pageWidth;
        const sliceHeightPx = availableHeight * pixelRatio;
  
        let yPositionPx = 0; // starting pixel position in contentCanvas
        let pageCount = 0;
  
        while (yPositionPx < contentCanvas.height) {
          // Set the slice height to the remaining height if less than a full slice
          const currentSliceHeight = Math.min(sliceHeightPx, contentCanvas.height - yPositionPx);
          canvasSlice.height = currentSliceHeight;
  
          const ctx = canvasSlice.getContext("2d");
          // Clear previous content
          ctx.clearRect(0, 0, canvasSlice.width, canvasSlice.height);
          // Draw the slice from the original canvas
          ctx.drawImage(
            contentCanvas,
            0,
            yPositionPx,
            contentCanvas.width,
            currentSliceHeight,
            0,
            0,
            canvasSlice.width,
            currentSliceHeight
          );
  
          // Convert this slice to an image
          const sliceData = canvasSlice.toDataURL("image/jpeg");
          // Calculate the slice's height in the PDF
          const slicePdfHeight = (currentSliceHeight * pageWidth) / contentCanvas.width;
  
          // If it's the first page, add header at the top; for additional pages, add a new page and header
          if (pageCount === 0) {
            addHeaderAndFooter();
            // Add the first slice below the header, starting at headerImgHeight + margin
            pdf.addImage(sliceData, "jpeg", 0, headerImgHeight + margin, pageWidth, slicePdfHeight);
          } else {
            pdf.addPage();
            addHeaderAndFooter();
            pdf.addImage(sliceData, "jpeg", 0, headerImgHeight + margin, pageWidth, slicePdfHeight);
          }
  
          yPositionPx += currentSliceHeight;
          pageCount++;
        }
      };
  
      // Capture and add two pages (or more if needed)
      await captureAndAddToPDF("firstPage");
      pdf.addPage();
      await captureAndAddToPDF("secondPage");
  
    //   const fileName = `report_${employeeId}.pdf`;
      const today = new Date();
      const formattedDate = `${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}-${today.getFullYear()}`;

    // Format the filename
      const employeeName = userData?.data?.name.replace(/\s+/g, "_"); // Replace spaces with underscores
      const fileName = `RoleReview–${employeeName}-${formattedDate}.pdf`;
      pdf.save(fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  const handleSaveComment = async () => {
    if (!commentText.trim()) {
        setToastMessage('Please enter a comment.');
        setToastSeverity('warning');
        setToastOpen(true);
        return;
    }

    try {
        if (reportVersionId) {
          const commentData = {
                    user_id: employeeId,
                    report_version_id: reportVersionId,
                    comment_text: commentText.trim(),
                  };

            await addComment(commentData);
            setToastMessage('Comment saved successfully.');
            setToastSeverity('success');
            setToastOpen(true);
            setCommentText('');
            console.log("isJwtUser",isJwtUser);
            
            if(isJwtUser){
              console.log("hello");
              
              setToastMessage('Thankyou for adding details');
              setToastSeverity('success');
              setToastOpen(true);
              
                        
              }else{
                setTimeout(() => {
                  navigate("/landing-page");
              }, 5000);
              }
            // navigate('/manager-dashboard');
        } else {
            setToastMessage('Failed to save the comment. Please try again.');
            setToastSeverity('error');
            setToastOpen(true);
        }
    } catch (error) {
        console.error('Error saving comment:', error);
        setToastMessage('Failed to save the comment. Please try again.');
        setToastSeverity('error');
        setToastOpen(true);
    }
};

const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }

    setToastOpen(false);
};

    // const handleDownload = async () => {
    //   handlePrint();
    // };
    // const handleDownload = async () => {
    //   if (downloadUrl && reportVersionId) {
    //     try {
    //       const response = await fetch(downloadUrl);
    //       if (!response.ok) throw new Error("Failed to fetch PDF");
  
    //       const blob = await response.blob();
    //       const downloadLink = document.createElement("a");
    //       downloadLink.href = URL.createObjectURL(blob);
    //       downloadLink.download = `manager_report_${employeeId}.pdf`;
    //       document.body.appendChild(downloadLink);
    //       downloadLink.click();
    //       document.body.removeChild(downloadLink);
    //     } catch (error) {
    //       console.error("Download failed, switching to print mode:", error);
    //       handlePrint(); 
    //     }
    //   } else {
    //     // alert("PDF not available, printing instead.");
    //     handlePrint();
    //   }
    // };

  return (
    <>
    <div id="pdfHeader">
      <ReportHeader />
      </div>
            <SectionWrap component="section" sx={{ position: "relative" }}>
            <ContainerWrap>
                <RowWrap>
                    <Col12Wrap>
                        {/* <Box id="viewPageContent">
                            <Firsttable userId={employeeId} />
                            <DashboardCharts userId={employeeId} />
                            <DataComp userId={employeeId} />
                            <WorkData userId={employeeId} />
                        </Box> */}
                         <Box id="firstPage">
                        <Firsttable userId={employeeId} />
                        <DashboardCharts userId={employeeId} />
                        {/* <DataComp userId={employeeId} /> */}
                        <Box id="dataComp">
                     <DataComp userId={employeeId} />
                </Box>
                    </Box>

                    {/* Page 2 Content */}
                    <Box id="secondPage" style={{ marginTop: "50px" }}>
                        <WorkData userId={employeeId} />
                    </Box>

                        {reportVersionId && (
                            <Box>
                                <TitleWrap>Add Comment</TitleWrap>
                                <TextField
                                    fullWidth
                                    placeholder="Enter your comment"
                                    multiline
                                    rows={4}
                                    value={commentText}
                                    onChange={(e) => setCommentText(e.target.value)}
                                    sx={{
                                        width: "100%",
                                        border: "1px solid #DADADA",
                                        borderRadius: "7px",
                                        marginBottom: "10px",
                                        "& .MuiInputBase-input": {
                                            fontSize: "16px",
                                            padding: "14px 20px",
                                        },
                                    }}
                                />
                                <CustomBtnSave onClick={handleSaveComment}>Save Comment</CustomBtnSave>
                            </Box>
                        )}
                    </Col12Wrap>
                </RowWrap>
            </ContainerWrap>
        </SectionWrap>
        <div id="pdfFooter">
      <ReportFooter />
      </div>

        {/* Centered Progress Message at the Top */}
        {isGenerating && (
            <Box
                sx={{
                    position: "absolute",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    color: "#fff",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    zIndex: 1000,
                }}
            >
                Generating Report: {progress}%
            </Box>
        )}

        {/* Download Icon Styling */}
        {/* <Box sx={{ display: "flex", justifyContent: "flex-end", position: "relative", mt: 2 }}> */}
            <IconButton
                color="primary"
                onClick={handleDownload}
                sx={{
                    position: "absolute",
                    top: "20px",
                    right: "10px",
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    padding: "8px",
                    borderRadius: "50%",
                    "&:hover": {
                        backgroundColor: "#f0f0f0",
                    },
                }}
            >
                <DownloadIcon fontSize="large" />
            </IconButton>
        {/* </Box> */}

        {/* Toaster (Snackbar) Positioned at Top-Right */}
        <Snackbar
            open={toastOpen}
            autoHideDuration={6000}
            onClose={handleCloseToast}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <Alert
                onClose={handleCloseToast}
                severity={toastSeverity}
                sx={{
                    width: "100%",
                    backgroundColor: toastSeverity === "error" ? "#f44336" : "#4caf50",
                    color: "#fff",
                    fontWeight: "bold",
                    borderRadius: "8px",
                }}
            >
                {toastMessage}
            </Alert>
        </Snackbar>
        </>
 
  );
};

export default ViewPage;



const SectionWrap = styled(Box)(() => ({
  padding: "50px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
// const CustomBtn = styled(Button)(() => ({
//   fontSize: "20px",
//   fontWeight: "400",
//   lineHeight: "1",
//   color: "#ffffff",
//   textTransform: "capitalize",
//   background: "#F28021",
//   borderColor: "#F28021",
//   borderRadius: "10px",
//   padding: "15px 20px",
//   boxShadow: "none !important",
// }));
// const TitleWrap = styled(Typography)(() => ({
//   fontSize: "20px",
//   fontWeight: "600",
//   lineHeight: "1.445",
//   color: "#000000",
//   marginBottom: "10px",
//   padding: "0",
// }));
// const CustomCancelBtn = styled(Button)(() => ({
//   fontSize: "16px",
//   fontWeight: "400",
//   lineHeight: "1",
//   color: "#ffffff",
//   textTransform: "capitalize",
//   background: "#d32f2f",
//   borderColor: "#d32f2f",
//   borderRadius: "10px",
//   padding: "13px 20px",
//   boxShadow: "none !important",
// }));
// const CustomBtnSave = styled(Button)(() => ({
//   fontSize: "16px",
//   fontWeight: "400",
//   lineHeight: "1",
//   color: "#ffffff",
//   textTransform: "capitalize",
//   background: "#1085AB",
//   borderColor: "#1085AB",
//   borderRadius: "10px",
//   padding: "13px 20px",
//   boxShadow: "none !important",
// }));
